import { atom } from "jotai";

// Timer State Atoms
export const activeBubbleAtom = atom(null);
export const timerAtom = atom(null);
export const elapsedTimeAtom = atom(0);
